module.exports = __webpack_public_path__ + "img/fastlearner_notcompleted.51839093.svg";